import * as React from 'react';
import { GridCallbackDetails, GridColDef, GridRowParams, MuiEvent } from '@mui/x-data-grid';
import { AMember, AMemberInfo, appdata } from '../internalModules';
import { StyledDataGrid, drawerTableStyle } from '../Graphics';
import { Box } from '@mui/material';
import UIMemberDialog from './UIMemberDialog';
import UIMemberIcon from './UIMemberIcon';

const columns: GridColDef[] = [
  { field: 'category', headerName: 'Category', width: 150 },
  { field: 'shape', headerName: 'Shape', width: 60, renderCell(params) {
    const member = appdata.getMember(String(params.id))
    return(
      <UIMemberIcon kind={member.kind} />
    )
  },},
  { field: 'name', headerName: 'Member Name', width: 540 },
]

type Props = {
  updateApp: Function
}

export default function UIMemberTable({updateApp}: Props) {

  const [selectedMember, setSelectedMember] = React.useState(AMember.getEmpty())
  const [dialogOpen, setDialogOpen] = React.useState(false)

  const rows = Array.from(appdata.members.values()).sort( 
    ( a,b ) => {
      const categoryA = appdata.getMaterial(a.materialGuid).category
      const categoryB = appdata.getMaterial(b.materialGuid).category
      const categoryOrder = categoryA.localeCompare(categoryB)
      const nameOrder = a.name.localeCompare(b.name)
      return categoryOrder || nameOrder
    }
  ).map( item => {
    return {
      id: item.guid,
      category: appdata.getMaterial(item.materialGuid).category,
      name: item.name,
    }
  })

  const toggleDialogOpen = (open: boolean) => (event: React.MouseEvent) => {
    setDialogOpen(open)
  }

  const handleAcceptDialog = (info: AMemberInfo) => {
    appdata.setMemberInfo(info.guid, info)
    setDialogOpen(false)
    updateApp()
  }

  function handleRowClick (params: GridRowParams, event: MuiEvent, details: GridCallbackDetails){
    const member = appdata.getMember(String(params.id))
    if(member.guid === '0'){
      return
    }
    setSelectedMember(member)
    setDialogOpen(true)
  }
  

  return (
    <>
      <div style={drawerTableStyle}>
        <StyledDataGrid
          rows={rows}
          columns={columns}
          pageSize={90}
          rowsPerPageOptions={[90]}
          density='compact'
          onRowClick={handleRowClick}
          hideFooter
        />
      </div>
      <Box sx={{ flexGrow: 1 }} padding={2}>
        <UIMemberDialog key={selectedMember.guid + 'edit'} memberGuid={selectedMember.guid}
          isOpen={dialogOpen} closeDialog={toggleDialogOpen(false)}
          acceptDialog={handleAcceptDialog} />
      </Box>
    </>
    
  )
}
